import styled from 'styled-components'
import {media, Row, Small} from '@modifi/ui'
import {white, red, darkGray, semiDarkGray} from '@modifi/colors'

import {H3} from '../../../../styles/typography'
import {FirstTradeFree, CnBadge} from '../../../../assets/graphics'

export const FormTile = styled.div`
  background: ${white};
  color: ${darkGray};
  box-shadow: 0 0 40px 10px rgba(139, 142, 146, 0.09);
  padding: 30px 40px 40px;
  height: 100%;
  position: relative;
  ${media.max.sm`
    padding: 30px 20px 30px;
  `}

  ${media.md`
    padding: 40px;
  `}

  ${media.lg`
    padding: 40px;
  `}
`

export const StyledFirstTradeFree = styled(FirstTradeFree)`
  position: absolute;
  top: 0;
  margin-top: -30px;
  left: 0;
  margin-left: -7px;
  height: 61px;
  width: 58px;
  ${media.md`
    margin-top: -15px;
    left: auto;
    margin-left: 0;
    right: 100%;
    margin-right: -20px;
    height: 80px;
    width: 75px;
  `}
`

export const StyledCnBadge = styled(CnBadge)`
  position: absolute;
  top: 0;
  margin-top: -30px;
  left: 0;
  margin-left: -7px;
  height: 61px;
  width: 58px;
  ${media.md`
    margin-top: -15px;
    left: auto;
    margin-left: 0;
    right: 100%;
    margin-right: -20px;
    height: 80px;
    width: 75px;
  `}
`

export const PhoneInputWrapper = styled.div`
  > div {
    padding-bottom: 0;
  }

  small {
    height: 36px;
  }
`

export const StyledAlert = styled.div`
  display: flex;
  align-items: center;
  color: ${red};

  > svg {
    margin-right: 10px;
  }
`

export const SuccessRow = styled(Row)`
  height: 100%;
  text-align: center;

  ${H3} {
    margin-top: 60px;
    ${media.smaller`
      text-align: center;
    `}
  }
`
export const SmallText = styled(Small)`
  display: block;
  margin-bottom: 20px;
  color: ${semiDarkGray};
`
